import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgDragAndDrop = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 4.381c0-.349.267-.631.631-.631H8.12c.348 0 .631.267.631.631V5.62a.621.621 0 01-.631.631H6.88a.621.621 0 01-.631-.631V4.38zm5 0c0-.349.268-.631.631-.631h1.238c.348 0 .631.267.631.631V5.62a.623.623 0 01-.631.631H11.88a.62.62 0 01-.631-.631V4.38zm-5 5c0-.349.267-.631.631-.631H8.12c.348 0 .631.267.631.631v1.238a.621.621 0 01-.631.631H6.88a.623.623 0 01-.631-.631V9.38zm5 0c0-.349.268-.631.631-.631h1.238c.348 0 .631.267.631.631v1.238a.623.623 0 01-.631.631H11.88a.622.622 0 01-.631-.631V9.38zm-5 5c0-.348.267-.631.631-.631H8.12c.348 0 .631.268.631.631v1.238a.621.621 0 01-.631.631H6.88a.623.623 0 01-.631-.631V14.38zm5 0c0-.348.268-.631.631-.631h1.238c.348 0 .631.268.631.631v1.238a.623.623 0 01-.631.631H11.88a.622.622 0 01-.631-.631V14.38z"
      />
    </Icon>
  );
};

export default SvgDragAndDrop;
